export function addHolidaySynchroniz()
{
    return({
        type:"ADD_HOLIDAY_SYNCHRONIZ"
    })
}